export const SHELVES_TABLE_COLUMNS_TEMPLATE = "repeat(4, 1fr) 2fr 1.5fr 1fr 1fr";
